"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.valueAsWeekday = exports.valueAsVector = exports.valueAsTime = exports.valueAsString = exports.valueAsRecord = exports.valueAsQuote = exports.valueAsNumber = exports.valueAsMonth = exports.valueAsDate = exports.valueAsBoolean = void 0;
const exception_1 = require("../exception");
const valueAs = (value, type) => {
    if (value.type !== type) {
        throw new exception_1.TypeError(`Unexpected ${value.type.toLowerCase()}; Was expecting ${type.toLowerCase()}.`);
    }
    return value;
};
const valueAsBoolean = (value) => valueAs(value, "Boolean").value;
exports.valueAsBoolean = valueAsBoolean;
const valueAsDate = (value) => valueAs(value, "Date");
exports.valueAsDate = valueAsDate;
const valueAsMonth = (value) => valueAs(value, "Month").value;
exports.valueAsMonth = valueAsMonth;
const valueAsNumber = (value, ...acceptedUnits) => {
    const number = valueAs(value, "Number");
    if (number.unit != null &&
        acceptedUnits.find((unit) => { var _a; return unit.symbol === ((_a = number.unit) === null || _a === void 0 ? void 0 : _a.symbol); }) == null) {
        throw new exception_1.TypeError(`Cannot use number of type ${number.unit.type.toLowerCase()} for this operation.`);
    }
    return number.value;
};
exports.valueAsNumber = valueAsNumber;
const valueAsQuote = (value) => valueAs(value, "Quote").quote;
exports.valueAsQuote = valueAsQuote;
const valueAsRecord = (value) => valueAs(value, "Record").elements;
exports.valueAsRecord = valueAsRecord;
const valueAsString = (value) => valueAs(value, "String").value;
exports.valueAsString = valueAsString;
const valueAsTime = (value) => valueAs(value, "Time");
exports.valueAsTime = valueAsTime;
const valueAsVector = (value) => valueAs(value, "Vector").elements;
exports.valueAsVector = valueAsVector;
const valueAsWeekday = (value) => valueAs(value, "Weekday").value;
exports.valueAsWeekday = valueAsWeekday;
